import React, { useState, useEffect } from 'react';
import { Snackbar, Button, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: 2 }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' }, 
          alignItems: 'center', 
          gap: 2.5,
          width: '100%',
          maxWidth: '600px',
          bgcolor: 'rgba(248, 249, 250, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          p: 3,
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            flex: 1, 
            color: 'text.primary',
            lineHeight: 1.6
          }}
        >
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies. 
          <Link 
            to="/cookies" 
            style={{ 
              marginLeft: '4px', 
              color: 'inherit',
              textDecoration: 'underline',
              fontWeight: 500
            }}
          >
            Learn more
          </Link>
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAccept}
          sx={{ 
            whiteSpace: 'nowrap',
            px: 4,
            py: 1,
            fontWeight: 500
          }}
        >
          Accept
        </Button>
      </Box>
    </Snackbar>
  );
};

export default CookieConsent; 